import * as v from 'valibot';
const macroItemSchema = v.object({
    device_id: v.number(),
    operation: v.string(),
    transmitter_id: v.number(),
});
export const macroSchema = v.object({
    id: v.number(),
    title: v.string(),
    active: v.boolean(),
    items: v.array(macroItemSchema),
});
